import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { addOptionToPurchase, updateOptionToPurchase } from 'src/app/core/store/form.actions';
import {
  AddOnType,
  DropDownOptions,
  MyPurchaseForm,
  StoreDropdowns,
} from 'src/app/shared/models/app-models';
import { AddOn } from 'src/app/shared/models/database-models';

@Component({
  selector: 'app-add-new-option-purchase',
  templateUrl: './add-new-option-purchase.component.html',
  styleUrls: ['./add-new-option-purchase.component.scss'],
})
export class AddNewOptionPurchaseComponent
  implements OnInit, OnDestroy, OnChanges {
  @Input() optionPurchaseNav!: MatSidenav;
  @Input() optionPurchaseEdit?: AddOn;
  @Input() title!: string;
  @Input() dataForm!: AddOn[];
  destory$: Subject<boolean> = new Subject<boolean>();
  destroy$: Subject<boolean> = new Subject<boolean>();
  UOMdropdown: DropDownOptions[] = [];
  Currdropdown!: DropDownOptions[];
  optionPurchase!: FormGroup;
  DescriptionControl!: FormControl;
  UOMControl!: FormControl;
  QuantityControl!: FormControl;
  CurrencyControl!: FormControl;
  UnitPriceControl!: FormControl;
  DurationYearsControl!: FormControl;
  DurationMonthsControl!: FormControl;
  totalPrice: string = 'SGD 1.00';
  mpNumber: string = '';
  formEdit!: AddOn;

  constructor(
    private _fb: FormBuilder,
    private store: Store<{
      dp: StoreDropdowns;
      form: MyPurchaseForm;
    }>,
    private route: ActivatedRoute
  ) {
    this.mpNumber = this.route.snapshot.params['id'].split(';')[0] as string;
    this.optionPurchase = this._fb.group({
      Description: ['', [Validators.required]],
      UnitOfMeasurement: [{ id: 6, value: 'Each' }, [Validators.required]],
      Quantity: [1, [Validators.required]],
      Currency: [{ id: 'SGD', value: 'SGD' }, [Validators.required]],
      UnitPrice: [1, [Validators.required]],
      DurationYears: ['0', [Validators.required]],
      DurationMonths: ['0', [Validators.required]],
    });
    this.DescriptionControl = this.optionPurchase.controls[
      'Description'
    ] as FormControl;
    this.UOMControl = this.optionPurchase.controls[
      'UnitOfMeasurement'
    ] as FormControl;
    this.QuantityControl = this.optionPurchase.controls[
      'Quantity'
    ] as FormControl;
    this.CurrencyControl = this.optionPurchase.controls[
      'Currency'
    ] as FormControl;
    this.UnitPriceControl = this.optionPurchase.controls[
      'UnitPrice'
    ] as FormControl;
    this.DurationYearsControl = this.optionPurchase.controls[
      'DurationYears'
    ] as FormControl;
    this.DurationMonthsControl = this.optionPurchase.controls[
      'DurationMonths'
    ] as FormControl;
    this.store
      .select('dp')
      .pipe(takeUntil(this.destory$))
      .subscribe((dp: StoreDropdowns) => {
        this.UOMdropdown = dp.UOM;
        this.Currdropdown = dp.Currency;
      });
  }

  async ngOnInit(): Promise<void> { }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (
      changes &&
      changes['optionPurchaseEdit'] &&
      changes['optionPurchaseEdit'].currentValue
    ) {
      this.formEdit = changes['optionPurchaseEdit'].currentValue;
      this.editForm(this.formEdit);
    }
  }

  restrictNegativeNumberInput(event: Event, decimalPlaces?: number): void {
    const inputElement = event.target as HTMLInputElement;
    const enteredValue = parseFloat(inputElement.value);
    const numberOfDecimals = enteredValue.toString().split('.')[1]?.length;
    if (!isNaN(enteredValue) && numberOfDecimals > (decimalPlaces ?? 2)) {
      inputElement.value = inputElement.valueAsNumber.toFixed(
        decimalPlaces ?? 2
      );
    }
    if (!isNaN(enteredValue) && enteredValue < 0) {
      inputElement.value = '0';
    }
    if (!isNaN(enteredValue) && enteredValue > 999999999) {
      inputElement.value = '0';
    }
  }

  async CalculateEastimateCost(event: any) {
    let unitOfMeasurement = this.optionPurchase.controls['UnitOfMeasurement']
      .value
      ? this.optionPurchase.controls['UnitOfMeasurement'].value['value']
      : null;
    let currencyCode = this.optionPurchase.controls['Currency'].value
      ? this.optionPurchase.controls['Currency'].value['value']
      : null;
    let quantity = this.optionPurchase.controls['Quantity'].value;
    let unitPrice = this.optionPurchase.controls['UnitPrice'].value;
    if (currencyCode && unitOfMeasurement) {
      let calculatedAmt: any = quantity * unitPrice;
      calculatedAmt = calculatedAmt.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      this.totalPrice = currencyCode + ' ' + calculatedAmt;
    }
  }

  addOptionToPurchase() {
    const isError = this.validateAdd();
    if (isError) {
      return;
    }
    if (this.formEdit) {
      // edit
      const formData: AddOn = this.getFormEditData();
      this.store.dispatch(updateOptionToPurchase({ option: formData }));
    } else {
      const formData: AddOn = this.getFormData();
      this.store.dispatch(addOptionToPurchase({ option: formData }));
    }
    this.resetForm();
    this.optionPurchaseNav.close();
  }

  resetForm() {
    this.optionPurchase.controls['Description'].setValue('');
    this.optionPurchase.controls['UnitOfMeasurement'].setValue({
      id: 6,
      value: 'Each',
    });
    this.optionPurchase.controls['Quantity'].setValue(1);
    this.optionPurchase.controls['Currency'].setValue({
      id: 'SGD',
      value: 'SGD',
    });
    this.optionPurchase.controls['UnitPrice'].setValue(1);
    this.optionPurchase.controls['DurationYears'].setValue('');
    this.optionPurchase.controls['DurationMonths'].setValue('');
  }

  editForm(form: AddOn) {
    const {
      Description,
      UnitOfMeasurements,
      Quantity,
      CurrencyCode,
      EstimatedUnitPrice,
      DurationYears,
      DurationMonths,
    } = form;
    const UOMOption = this.UOMdropdown?.find(
      (item) => item.value === UnitOfMeasurements
    );
    const currOption = this.Currdropdown?.find(
      (item) => item.value === CurrencyCode
    );

    this.optionPurchase.controls['Description'].setValue(Description);
    this.optionPurchase.controls['UnitOfMeasurement'].setValue(UOMOption);
    this.optionPurchase.controls['Quantity'].setValue(Quantity);
    this.optionPurchase.controls['Currency'].setValue(currOption);
    this.optionPurchase.controls['UnitPrice'].setValue(EstimatedUnitPrice);
    this.optionPurchase.controls['DurationYears'].setValue(DurationYears);
    this.optionPurchase.controls['DurationMonths'].setValue(DurationMonths);
    this.CalculateEastimateCost(null);
  }

  validateAdd() {
    const errorDescription = this.optionPurchase.controls['Description'].errors;
    const errorUnitOfMeasurement =
      this.optionPurchase.controls['UnitOfMeasurement'].errors;
    const errorQuantity = this.optionPurchase.controls['Quantity'].errors;
    const errorCurrency = this.optionPurchase.controls['Currency'].errors;
    const errorUnitPrice = this.optionPurchase.controls['UnitPrice'].errors;
    const errorDurationYears =
      this.optionPurchase.controls['DurationYears'].errors;
    const errorDurationMonths =
      this.optionPurchase.controls['DurationMonths'].errors;
    if (
      errorDescription ||
      errorUnitOfMeasurement ||
      errorQuantity ||
      errorCurrency ||
      errorUnitPrice
    ) {
      alert('* field are required.');
      return true;
    } else if (
      (this.optionPurchase.controls['DurationYears'].value == 0 && this.optionPurchase.controls['DurationMonths'].value == 0) ||
      (this.optionPurchase.controls['DurationMonths'].value >= 12)
    ) {
      alert('The duration provided is invalid. If the Duration (of) Years is 0, then the Duration (of) Months should not be 0, and if there is a Duration (of) Months, it should not exceed 12 months.');
      return true;
    } else {
      return false;
    }
  }

  getFormData() {
    const data: AddOn = {
      ItemAddOnId: null,
      PurchaseItemId: null,
      MPDocumentNumber: this.mpNumber,
      Quantity: this.optionPurchase.controls['Quantity'].value,
      DurationYears: this.optionPurchase.controls['DurationYears'].value,
      DurationMonths: this.optionPurchase.controls['DurationMonths'].value,
      Description: this.optionPurchase.controls['Description'].value,
      UnitOfMeasurements:
        this.optionPurchase.controls['UnitOfMeasurement'].value?.value,
      CurrencyCode: this.optionPurchase.controls['Currency'].value?.value,
      EstimatedUnitPrice: this.optionPurchase.controls['UnitPrice'].value,
      AddOnTypeId: AddOnType.OptionToPurchase,
      isDeleted: false,
      Strikethrough: false,
      // index: this.dataForm.length + 1
    };
    return data;
  }

  getFormEditData() {
    const data: AddOn = {
      ...this.formEdit,
      MPDocumentNumber: this.mpNumber,
      Quantity: this.optionPurchase.controls['Quantity'].value,
      DurationYears: this.optionPurchase.controls['DurationYears'].value,
      DurationMonths: this.optionPurchase.controls['DurationMonths'].value,
      Description: this.optionPurchase.controls['Description'].value,
      UnitOfMeasurements:
        this.optionPurchase.controls['UnitOfMeasurement'].value?.value,
      CurrencyCode: this.optionPurchase.controls['Currency'].value?.value,
      EstimatedUnitPrice: this.optionPurchase.controls['UnitPrice'].value,
      AddOnTypeId: AddOnType.OptionToPurchase,
      isDeleted: false,
      Strikethrough: false,
    };
    return data;
  }


  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
